(function () {
  'use strict';

  // Mobile nav toggle
  document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
    var navId = btn.getAttribute('aria-controls');
    var nav = navId ? document.getElementById(navId) : null;
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Footer year
  document.querySelectorAll('[data-year]').forEach(function (el) {
    el.textContent = String(new Date().getFullYear());
  });

  // Product gallery — thumbs + swipeable main stage
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var stage = gallery.querySelector('[data-gallery-stage]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-dot]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (!track || !slides.length) return;

    var index = 0;
    var startX = 0;
    var deltaX = 0;
    var dragging = false;

    function goTo(i, animate) {
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      index = i;
      if (animate === false) track.style.transition = 'none';
      else track.style.transition = '';
      track.style.transform = 'translate3d(' + -index * 100 + '%,0,0)';
      slides.forEach(function (slide, n) {
        var on = n === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, n) {
        var on = n === index;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      dots.forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === index);
      });
      var activeThumb = thumbs[index];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      if (animate === false) {
        track.offsetHeight;
        track.style.transition = '';
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = parseInt(thumb.getAttribute('data-index'), 10);
        if (!isNaN(i)) goTo(i);
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index'), 10);
        if (!isNaN(i)) goTo(i);
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });

    function onStart(x) {
      dragging = true;
      startX = x;
      deltaX = 0;
      track.style.transition = 'none';
    }
    function onMove(x) {
      if (!dragging) return;
      deltaX = x - startX;
      var pct = (deltaX / stage.offsetWidth) * 100;
      track.style.transform = 'translate3d(' + (-index * 100 + pct) + '%,0,0)';
    }
    function onEnd() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      if (Math.abs(deltaX) > stage.offsetWidth * 0.18) {
        goTo(deltaX < 0 ? index + 1 : index - 1);
      } else {
        goTo(index);
      }
      deltaX = 0;
    }

    if (stage && slides.length > 1) {
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        onStart(e.touches[0].clientX);
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (!dragging || e.touches.length !== 1) return;
        onMove(e.touches[0].clientX);
      }, { passive: true });
      stage.addEventListener('touchend', onEnd);
      stage.addEventListener('touchcancel', onEnd);

      stage.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        e.preventDefault();
        onStart(e.clientX);
      });
      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        onMove(e.clientX);
      });
      window.addEventListener('mouseup', onEnd);
    }

    goTo(0, false);
  });

  // Bundle / offer selector updates price display + sticky CTA
  document.querySelectorAll('[data-offer-group]').forEach(function (group) {
    var form = group.closest('form') || document;
    var offers = group.querySelectorAll('[data-offer]');
    var priceNow = document.querySelector('[data-price-now]');
    var priceWas = document.querySelector('[data-price-was]');
    var priceSave = document.querySelector('[data-price-save]');
    var atcPrice = document.querySelector('[data-atc-price]');
    var sticky = document.querySelector('[data-sticky-cta]');
    var perDay = document.querySelector('[data-per-day]');
    var variantInput = form.querySelector('[name="id"]');

    function money(cents) {
      try {
        if (window.Shopify && Shopify.formatMoney) {
          return Shopify.formatMoney(cents, window.themeMoneyFormat || '${{amount}}');
        }
      } catch (e) {}
      return '$' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
    }

    function select(offer) {
      offers.forEach(function (o) {
        o.classList.remove('sel');
      });
      offer.classList.add('sel');
      var radio = offer.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;

      var price = parseInt(offer.getAttribute('data-price'), 10);
      var compare = parseInt(offer.getAttribute('data-compare') || '0', 10);
      var units = parseInt(offer.getAttribute('data-units') || '1', 10);
      var variantId = offer.getAttribute('data-variant-id');

      if (variantInput && variantId) variantInput.value = variantId;
      if (priceNow && !isNaN(price)) priceNow.textContent = money(price);
      if (priceWas) {
        if (compare > price) {
          priceWas.textContent = money(compare);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (priceSave) {
        if (compare > price) {
          priceSave.textContent = 'Save ' + money(compare - price);
          priceSave.style.display = '';
        } else {
          priceSave.style.display = 'none';
        }
      }
      if (atcPrice && !isNaN(price)) atcPrice.textContent = money(price);
      if (sticky) {
        var sp = sticky.querySelector('.sp');
        if (sp && !isNaN(price)) {
          sp.innerHTML = money(price) + '<small>' + units + ' warmer' + (units > 1 ? 's' : '') + '</small>';
        }
      }
      if (perDay) {
        perDay.textContent =
          units === 1
            ? 'Just about $0.15/day of warmth across an average winter.'
            : 'About $0.15/day each — warm feet everywhere you sit.';
      }
    }

    offers.forEach(function (offer) {
      offer.addEventListener('click', function () {
        select(offer);
      });
      offer.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          select(offer);
        }
      });
    });

    var selected = group.querySelector('[data-offer].sel') || offers[0];
    if (selected) select(selected);
  });

  function moneyFormat(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.themeMoneyFormat || '${{amount}}');
      }
    } catch (err) {}
    return '$' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
  }

  function renderCartDrawer(cart) {
    var body = document.querySelector('[data-cart-drawer-body]');
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!body || !drawer) return;
    if (!cart || !cart.item_count) {
      body.innerHTML = '<div class="drawer__empty"><p>Your cart was updated.</p><a href="/collections/all" class="btn btn-accent" data-drawer-close>Continue shopping</a></div>';
      return;
    }
    var html = '<ul class="drawer-cart-items">';
    (cart.items || []).forEach(function (item) {
      html += '<li class="drawer-cart-item">';
      if (item.image) {
        html += '<a href="' + item.url + '" class="drawer-cart-item__media"><img src="' + item.image + '" alt="" width="72" height="72" loading="lazy"></a>';
      }
      html += '<div class="drawer-cart-item__meta">';
      html += '<a href="' + item.url + '" class="drawer-cart-item__title">' + (item.product_title || item.title) + '</a>';
      if (item.variant_title) html += '<p class="drawer-cart-item__variant">' + item.variant_title + '</p>';
      html += '<div class="drawer-cart-item__row"><span class="drawer-cart-item__qty">Qty ' + item.quantity + '</span>';
      html += '<span class="drawer-cart-item__price">' + moneyFormat(item.final_line_price) + '</span></div>';
      html += '</div></li>';
    });
    html += '</ul>';
    body.innerHTML = html;
    var sub = drawer.querySelector('[data-cart-drawer-subtotal]');
    if (sub) sub.textContent = moneyFormat(cart.total_price);
    var footer = drawer.querySelector('.drawer__footer');
    if (!footer) {
      var foot = document.createElement('div');
      foot.className = 'drawer__footer';
      foot.innerHTML = '<div class="drawer__subtotal"><span>Subtotal</span><strong data-cart-drawer-subtotal>' + moneyFormat(cart.total_price) + '</strong></div>' +
        '<a href="/cart" class="btn btn-ghost btn-block">View cart</a>' +
        '<form action="/cart" method="post"><button type="submit" name="checkout" class="btn btn-accent btn-block">Checkout</button></form>';
      drawer.querySelector('.drawer__panel').appendChild(foot);
    }
  }

  // Drawers (cart + search)
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var focusable = drawer.querySelector('input, button, select, textarea, a[href]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer.is-open')) {
      document.body.classList.remove('drawer-open');
    }
  }
  function closeAllDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  }

  document.querySelectorAll('[data-open-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openDrawer(document.querySelector('[data-cart-drawer]'));
    });
  });
  document.querySelectorAll('[data-open-search]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openDrawer(document.querySelector('[data-search-drawer]'));
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      closeDrawer(el.closest('.drawer'));
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
  });

  // Variant dropdown picker
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var variantId = opt.getAttribute('data-variant-id') || opt.value;
      var price = parseInt(opt.getAttribute('data-price'), 10);
      var compare = parseInt(opt.getAttribute('data-compare') || '0', 10);
      var form = select.closest('form');
      var variantInput = form ? form.querySelector('[name="id"]') : null;
      if (variantInput && variantId) variantInput.value = variantId;
      var priceNow = document.querySelector('[data-price-now]');
      var priceWas = document.querySelector('[data-price-was]');
      var atcPrice = document.querySelector('[data-atc-price]');
      function money(cents) {
        try {
          if (window.Shopify && Shopify.formatMoney) {
            return Shopify.formatMoney(cents, window.themeMoneyFormat || '${{amount}}');
          }
        } catch (err) {}
        return '$' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
      }
      if (priceNow && !isNaN(price)) priceNow.textContent = money(price);
      if (priceWas) {
        if (compare > price) {
          priceWas.textContent = money(compare);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (atcPrice && !isNaN(price)) atcPrice.textContent = money(price);
    });
  });

  // AJAX add to cart
  document.querySelectorAll('form.product-form, [data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var toast = document.querySelector('[data-cart-toast]');
      var fd = new FormData(form);
      if (btn) btn.disabled = true;

      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add_failed');
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = String(cart.item_count || 0);
          });
          if (window.themeSettings && window.themeSettings.cartType === 'drawer') {
            renderCartDrawer(cart);
            openDrawer(document.querySelector('[data-cart-drawer]'));
          } else if (toast) {
            toast.classList.add('show');
            setTimeout(function () {
              toast.classList.remove('show');
            }, 1800);
          }
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (btn) btn.disabled = false;
        });
    });
  });

  // Sticky ATC triggers main form submit
  document.querySelectorAll('[data-sticky-atc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.querySelector('form.product-form, [data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  });

  // Track order demo lookup (configurable endpoint)
  document.querySelectorAll('[data-track-form]').forEach(function (form) {
    var orderNo = form.querySelector('[name="orderNo"]');
    var email = form.querySelector('[name="email"]');
    var fldOrder = form.querySelector('[data-fld-order]');
    var fldEmail = form.querySelector('[data-fld-email]');
    var btn = form.querySelector('[type="submit"]');
    var root = form.closest('[data-track-root]') || document;
    var states = {
      empty: root.querySelector('[data-state="empty"]'),
      loading: root.querySelector('[data-state="loading"]'),
      error: root.querySelector('[data-state="error"]'),
      success: root.querySelector('[data-state="success"]')
    };
    var endpoint = form.getAttribute('data-track-endpoint') || '';
    var demoOrder = form.getAttribute('data-demo-order') || '10428';

    function show(name) {
      Object.keys(states).forEach(function (k) {
        if (states[k]) states[k].classList.toggle('active', k === name);
      });
    }
    function validEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }
    function validate() {
      var ok = true;
      if (!orderNo.value.trim()) {
        fldOrder.classList.add('show-err');
        orderNo.classList.add('err');
        ok = false;
      } else {
        fldOrder.classList.remove('show-err');
        orderNo.classList.remove('err');
      }
      if (!validEmail(email.value.trim())) {
        fldEmail.classList.add('show-err');
        email.classList.add('err');
        ok = false;
      } else {
        fldEmail.classList.remove('show-err');
        email.classList.remove('err');
      }
      return ok;
    }

    orderNo.addEventListener('input', function () {
      if (orderNo.value.trim()) {
        fldOrder.classList.remove('show-err');
        orderNo.classList.remove('err');
      }
    });
    email.addEventListener('input', function () {
      if (validEmail(email.value.trim())) {
        fldEmail.classList.remove('show-err');
        email.classList.remove('err');
      }
    });

    function applySteps(idx) {
      var lis = root.querySelectorAll('[data-timeline] li');
      for (var i = 0; i < lis.length; i++) {
        lis[i].classList.remove('done', 'current', 'pending');
        lis[i].classList.add(i < idx ? 'done' : i === idx ? 'current' : 'pending');
      }
    }

    function renderSuccess(d) {
      var okOrder = root.querySelector('[data-ok-order]');
      var okMeta = root.querySelector('[data-ok-meta]');
      var okChip = root.querySelector('[data-ok-chip]');
      var okEta = root.querySelector('[data-ok-eta]');
      var carrierBtn = root.querySelector('[data-carrier-btn]');
      if (okOrder) okOrder.textContent = d.order;
      if (okMeta) okMeta.textContent = d.items + ' · ' + d.placed;
      if (okChip) okChip.textContent = d.status;
      if (okEta) okEta.textContent = d.eta;
      if (carrierBtn) carrierBtn.setAttribute('href', d.carrierUrl || '#');
      applySteps(d.stepIndex);
      show('success');
    }

    function trackOrder(orderNumber, emailAddress) {
      if (endpoint) {
        var url =
          endpoint +
          (endpoint.indexOf('?') > -1 ? '&' : '?') +
          'order=' +
          encodeURIComponent(orderNumber) +
          '&email=' +
          encodeURIComponent(emailAddress);
        return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
          if (!r.ok) throw new Error('lookup_failed');
          return r.json();
        });
      }
      // Mock demo until a tracking endpoint is configured in the Theme Editor
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          var num = orderNumber.replace(/[^0-9]/g, '');
          if (num.indexOf(demoOrder.replace(/[^0-9]/g, '')) > -1) {
            resolve({
              found: true,
              order: '#TR' + demoOrder.replace(/[^0-9]/g, ''),
              items: '1 × Under-Desk Foot Warmer',
              placed: 'placed 3 days ago',
              status: 'In transit',
              stepIndex: 2,
              eta: 'Carrier ETA available once tracking is connected',
              carrierUrl: '#'
            });
          } else if (num.length >= 4) {
            resolve({ found: false, reason: 'notfound' });
          } else {
            reject(new Error('lookup_failed'));
          }
        }, 1400);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate()) {
        (fldOrder.classList.contains('show-err') ? orderNo : email).focus();
        return;
      }
      btn.disabled = true;
      show('loading');
      trackOrder(orderNo.value.trim(), email.value.trim())
        .then(function (d) {
          btn.disabled = false;
          if (d && d.found) {
            renderSuccess(d);
          } else {
            var errText = root.querySelector('[data-err-text]');
            if (errText) {
              errText.textContent =
                "We couldn't find an order matching that number and email. Double-check both and try again — or contact us and we'll look it up.";
            }
            show('error');
          }
        })
        .catch(function () {
          btn.disabled = false;
          var errText = root.querySelector('[data-err-text]');
          if (errText) {
            errText.textContent =
              'Something went wrong looking up your order. Please try again in a moment, or email our team.';
          }
          show('error');
        });
    });
  });
})();
